import { STATUS } from "@/constant/statusConstants";

export const EditCompetitionInitialValues = (localeCodes, showData) => ({
  sport_id: showData?.data?.sport?.id || "",
  competition_group_id: showData?.data?.competition_group?.id || "",
  code: showData?.data?.code || "",
  localizations: localeCodes.reduce((acc, localeCode) => {
    acc[localeCode] = showData?.data?.localization_contents?.[localeCode] ?? "";
    return acc;
  }, {}),
  icon: null,
  status: showData?.data?.status || STATUS.INACTIVE,
});
